import {
  Accordion,
  AccordionControl,
  AccordionItem,
  AccordionPanel,
  Divider,
  Group,
  Select,
  Title,
} from "@mantine/core";
import { SelectionSectorType } from "../../constants/enum";
import React, { useState } from "react";
import ChangeSector from "./changeSector/changeSector";
import { HallPartOption } from "../../constants/types";

interface Props {
  px?: string;
  selectionSectorType: string;
  setSelectionSectorType: React.Dispatch<React.SetStateAction<string>>;
  setSelectionSectorNameChange: React.Dispatch<
    React.SetStateAction<HallPartOption | null>
  >;
  t: (key: string) => string;
}

const SelectionMode: React.FC<Props> = ({
  px,
  selectionSectorType,
  setSelectionSectorType,
  setSelectionSectorNameChange,
  t,
}) => {
  const [isOpenChangeSector, setIsOpenChangeSector] = useState(true);
  const selectionOptions = [
    {
      value: SelectionSectorType.ENTIRE,
      label: t(
        "scheme.redactor.panelOptions.selectionMode.sectorSelectionType.entire"
      ),
    },
    {
      value: SelectionSectorType.ROW,
      label: t(
        "scheme.redactor.panelOptions.selectionMode.sectorSelectionType.row"
      ),
    },
  ];
  const handleSelectionChange = (type: string) => {
    setSelectionSectorType(type);
  };

  return (
    <>
      <Divider mt={15} mb={10} />
      <Group px={px} gap={10}>
        <Title order={4}>
          {t("scheme.redactor.panelOptions.selectionMode.title")}
        </Title>

        <Select
          w={"100%"}
          data={selectionOptions}
          value={selectionSectorType}
          onChange={handleSelectionChange}
          label={t(
            "scheme.redactor.panelOptions.selectionMode.sectorSelectionType.title"
          )}
        />
      </Group>

      <Divider mt={15} mb={10} variant={"dashed"} />
      <Group px={px}>
        <Accordion
          w={"100%"}
          value={isOpenChangeSector ? "sector_change" : ""}
          onChange={(value) => setIsOpenChangeSector(value === "sector_change")}
          variant="contained"
        >
          <AccordionItem value="sector_change">
            <AccordionControl>
              <Title order={5}>
                {t(
                  "scheme.redactor.panelOptions.setSector.selectHallPart.label"
                )}
              </Title>
            </AccordionControl>
            <AccordionPanel>
              <ChangeSector
                t={t}
                setSelectionSectorNameChange={setSelectionSectorNameChange}
              />
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Group>
    </>
  );
};

export default React.memo(SelectionMode);
